import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWebchat = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <rect
      width={32}
      height={32}
      fill="#00C5F2"
      rx={16}
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M6 12.625A6.625 6.625 0 0 1 12.625 6h6.75A6.625 6.625 0 0 1 26 12.625v.563c0 3.219-2.51 5.852-5.679 6.05l-7.608 6.521a1 1 0 0 1-1.62-1.001l1.377-5.51A6.625 6.625 0 0 1 6 12.625M12.625 8a4.625 4.625 0 0 0 0 9.25h1.125a1 1 0 0 1 .97 1.242l-.927 3.707 5.494-4.708a1 1 0 0 1 .65-.241A4.06 4.06 0 0 0 24 13.188v-.563A4.625 4.625 0 0 0 19.375 8z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWebchat);

export default ForwardRef;
